import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Grid, Typography, Button, Divider, Box } from "@material-ui/core";
import Drawer from "@mui/material/Drawer";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import ClearIcon from "@mui/icons-material/ClearOutlined";
import Checkbox from "@mui/joy/Checkbox";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import CloseIcon from "@mui/icons-material/Close";
import Sheet from "@mui/joy/Sheet";
import { BUTTON_COLOR, TEXT_COLOR } from "../../utils/constant";
import VegIcon from "../../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../../assets/images/Non Veg Icon 1.svg";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

export default function FilterPopup(props) {
  const {
    dietaryArray,
    itemList,
    setItemList,
    setOpen,
    open,storeInfoConfig,
    storeInfo,checkedItems, setCheckedItems,
    setDietaryFilter,
    setSelectedfilter,
    selectedfilter,
  } = props;

  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  const reduxConfig = sessionReducer.store_config || storeInfoConfig || props.sessionReducer?.store_config || {};
  
  const primaryColor = reduxConfig?.general_config?.primary_color || "#272727";
  const secondaryColor = reduxConfig?.general_config?.secondary_color || "#272727";

  const [radioCheck, setRadioCheck] = useState("");

  const [originalItemList, setOriginalItemList] = useState([]);

  // Store original item list on first render
  useEffect(() => {
    if (originalItemList.length === 0 && itemList.length > 0) {
      setOriginalItemList([...itemList]);
    }
  }, [itemList, originalItemList.length]);

  // Check if any items have dietary information
  // const hasDietaryItems = originalItemList.some(
  //   (item) =>
  //     item.dietary && (item.dietary === "veg" && item.dietary === "non-veg")
  // );

// const hasVeg = originalItemList.some(item => item?.dietary?.toLowerCase()?.trim() === "veg");
// const hasNonVeg = originalItemList.some(item => {
//   const d = item?.dietary?.toLowerCase()?.trim();
//   return d === "non-veg" || d === "nonveg" || d === "non veg" || d === "non_veg" || d === "egg" || d === "eggetarian" || d === "eggiterian" || d === "eggitarian";
// });

const hasDietaryItems = true; // Always show dietary filters

  // Handle checkbox state changes
  const handleCheckboxChange = (item) => {
  
    setCheckedItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  // Apply filters (dietary and price) whenever selected filter or checked items change
  useEffect(() => {
    let filteredItems = [...originalItemList];

    // Apply dietary filter if any dietary items are checked
    if (checkedItems?.length > 0) {
      filteredItems = filteredItems.filter((item) => {
        if (!item.dietary) return false;

        // Map the checkbox labels to actual dietary values
        const dietaryFilters = checkedItems.map((filter) => {
          if (filter === "Veg") return "veg";
          if (filter === "Non-veg") return "non-veg";
          return filter.toLowerCase();
        });

        return dietaryFilters.includes(item.dietary.toLowerCase());
      });
    }

    // Apply price sorting filter
    if (selectedfilter === "low") {
      filteredItems.sort((a, b) => {
        const priceA = a.item_variant[0]?.plu || 0;
        const priceB = b.item_variant[0]?.plu || 0;
        return priceA - priceB;
      });
    } else if (selectedfilter === "high") {
      filteredItems.sort((a, b) => {
        const priceA = a.item_variant[0]?.plu || 0;
        const priceB = b.item_variant[0]?.plu || 0;
        return priceB - priceA;
      });
    }

    if (setDietaryFilter) {
      setDietaryFilter(checkedItems?.map((f) => f.toLowerCase()) || []);
    }
    if (setItemList) {
      setItemList(filteredItems);
    }
  }, [
    selectedfilter,
    checkedItems,
    originalItemList,
    setItemList,
    setDietaryFilter,
  ]);

  const radioOptions = [
    { label: "Low to High", value: "low" },
    { label: "High to Low", value: "high" },
  ];

  const handleApplyFilter = () => {
    setRadioCheck(selectedfilter);
    setOpen(false); // Close filter popup
  };

  const handleResetFilter = () => {
    setCheckedItems([]);
    setSelectedfilter(""); // Reset selected price filter
    setRadioCheck("");
    setItemList([...originalItemList]); // Reset to original list
    setDietaryFilter([]);
    setOpen(false);
  };

  // Handle sort option click/deselect
  const handleSortOptionClick = (value) => {
    if (selectedfilter === value) {
      // If already selected, deselect it
      setSelectedfilter("");
      setRadioCheck("");
    } else {
      // Select the option
      setSelectedfilter(value);
      setRadioCheck(value);
    }
  };

  return (
    <>
      <SwipeableDrawer
        open={open}
        anchor={"bottom"}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        disableSwipeToOpen={true}
        PaperProps={{
          style: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxHeight: "90%",
          },
        }}
      >
        <Grid
          style={{
            // backgroundColor: "rgb(248, 249, 250",
          }}
        >
          <Grid>
            <CloseIcon
              style={{
                position: "absolute",
                top: "1.3rem",
                right: "11px",
                color: primaryColor || "black",
              }}
              onClick={() => {
                setOpen(false);
              }}
            />
          </Grid>
          <Grid>
            <Typography
              style={{
                fontFamily: "satoshi",
                backgroundColor: "white",
                boxShadow: " rgba(0, 0, 0, 0.08) 0px 2px 12px",
                textAlign: "left",
                color: primaryColor || "black",
                padding: "1rem",
                fontWeight: "bold",
              }}
              variant="h6"
            >
              Filters and Sorting
            </Typography>
          </Grid>

          <DialogContent>
            {" "}
            <DialogContentText
              style={{
                color: primaryColor || "black",
                fontWeight: "600",
                margin: "10px 0px",
              }}
            >
              Sort by
            </DialogContentText>
            <Grid
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "5px 0px 30px 0px",
              }}
            >
              <div
                style={{
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  // paddingLeft: "1rem",
                  scrollbarWidth: "none", // Firefox
                  msOverflowStyle: "none", // IE 10+
                }}
              >
                <style>
                  {`
      /* Hide scrollbar for WebKit browsers */
      div::-webkit-scrollbar {
        display: none;
      }
    `}
                </style>

                <Grid
                  container
                  spacing={2}
                  style={{
                    flexWrap: "nowrap",
                  }}
                >
                  {radioOptions.map((value) => (
                    <Grid item key={value.value} style={{ flexShrink: 0 }}>
                      <Button
                        variant="outlined"
                        onClick={() => handleSortOptionClick(value.value)}
                        style={{
                          textTransform: "none",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          fontWeight: "500",
                          fontSize: "13px",
                          fontFamily: "Satoshi",
                          color: radioCheck === value.value ? (primaryColor || "#333333") : "#333333",
                          backgroundColor: "#fff",
                          border:
                            radioCheck === value.value
                              ? `1px solid ${
                                  primaryColor || BUTTON_COLOR
                                }`
                              : "1px solid #e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          whiteSpace: "nowrap",
                          height: "36px",
                          boxSizing: "border-box",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>
                            Price - {value.label}
                          </span>
                        </div>
                        {radioCheck === value.value && (
                          <span
                            style={{
                              marginLeft: "8px",
                              color: primaryColor || "#333333",
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            ×
                          </span>
                        )}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </div>
            </Grid>
            {hasDietaryItems && (
              <>
                <DialogContentText
                  style={{
                    margin: "10px 0px",
                    color: primaryColor || "black",
                    fontWeight: "600",
                  }}
                >
                  Veg/Non-veg preference
                </DialogContentText>
                <Grid
                  style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    padding: "15px 0px",
                    margin: "0px 0px",
                  }}
                >
                  <Grid container spacing={2} 
                  // style={{ paddingLeft: "1rem" }}
                  >
                    {["Veg", "Non-veg"].map((item) => {
                      const icon =
                        item === "Veg" ? (
                          <img
                            src={VegIcon}
                            style={{ marginRight: "8px", width: "15px" }}
                          />
                        ) : (
                          <img
                            src={NonVegIcon}
                            style={{ marginRight: "8px", width: "15px" }}
                          />
                        );

                      return (
                        <Grid item key={item}>
                          <Button
                            variant="outlined"
                            onClick={() => handleCheckboxChange(item)}
                            style={{
                              textTransform: "none",
                              padding: "8px 16px",
                              borderRadius: "8px",
                              fontWeight: "500",
                              fontSize: "13px",
                              fontFamily: "Satoshi",
                              color: checkedItems?.includes(item) ? (primaryColor || "#333333") : "#333333",
                              backgroundColor: "#fff",
                              border: checkedItems?.includes(item)
                                ? `1px solid ${
                                    primaryColor || BUTTON_COLOR
                                  }`
                                : "1px solid #e0e0e0",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              height: "36px",
                              boxSizing: "border-box",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {icon} {item}
                            </div>
                            {checkedItems?.includes(item) && (
                              <span
                                style={{
                                  marginLeft: "8px",
                                  fontSize: "14px",
                                  color: primaryColor || "#333333",
                                  fontWeight: "bold",
                                }}
                              >
                                ×
                              </span>
                            )}
                          </Button>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </>
            )}
          </DialogContent>

          <Box
            style={{
              display: "flex",
              gap: "10px",
              padding: "16px 5%",
              boxShadow: "rgba(0, 0, 0, 0.05) 0px -2px 10px",
            }}
            display="flex"
            justifyContent="center"
          >
            <Button
              style={{
                fontSize: "1rem",
                borderRadius: "8px",
                width: "50%",
                padding: "0.8rem 1rem",
                fontWeight: "Bold",
                lineHeight1: "1.5",
                color: primaryColor || "black",
                border: `1px solid ${primaryColor || BUTTON_COLOR}`,
                backgroundColor: "transparent",
              }}
              variant="outlined"
              onClick={handleResetFilter}
            >
              Reset
            </Button>
            <Button
              style={{
                fontSize: "1rem",
                borderRadius: "8px",
                width: "50%",
                padding: "0.8rem 1rem",
                fontWeight: "Bold",
                lineHeight1: "1.5",
                color:  "white"  || TEXT_COLOR,
                backgroundColor: primaryColor || BUTTON_COLOR,
              }}
              variant="contained"
              onClick={handleApplyFilter}
            >
              Apply
            </Button>
          </Box>
        </Grid>
      </SwipeableDrawer>
    </>
  );
}
